import {hoistCmp} from '@xh/hoist/core';
import {DealDialogModel} from './DealDialogModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {filler, hbox, hframe, img, input, placeholder, vframe} from '@xh/hoist/cmp/layout';
import {button} from '@xh/hoist/desktop/cmp/button';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {dateInput, numberInput, select, textArea, textInput} from '@xh/hoist/desktop/cmp/input';
import {defaultRsOptions} from '../../../cmp/SelectOptions';
import {grid} from '@xh/hoist/cmp/grid';
import './DealDialog.scss';
import {percentageIcon} from '../../../../core/Icons';

export const dealDialog = hoistCmp.factory<DealDialogModel>(({model}) =>
    dialog({
        className: 'deal-dialog',
        icon: Icon.home(),
        title: 'Deal',
        canOutsideClickClose: false,
        isOpen: model.isOpen,
        onClose: () => model.close(),
        item: panel({
            item: hframe(dealForm(), vframe({style: {width: 350}, items: [imagePanel(), documentsPanel()]})),
            bbar: bbar(),
            mask: model.apiTask
        })
    })
);

const dealForm = hoistCmp.factory<DealDialogModel>(({model}) => {
    return panel({
        className: 'deal-dialog__sub-panel',
        modelConfig: {
            side: 'left',
            defaultSize: 450,
            showSplitter: false,
            collapsible: false,
            resizable: false
        },
        title: 'Details',
        compactHeader: true,
        item: form({
            model: model.formModel,
            fieldDefaults: {commitOnChange: true, minimal: true},
            item: vframe(
                hbox(
                    formField({
                        field: 'securityId',
                        label: 'Deal',
                        flex: 1,
                        item: select({
                            className: 'distribution-security-select',
                            options: model.securitieOptions,
                            rsOptions: defaultRsOptions()
                        })
                    }),
                    formField({
                        field: 'status',
                        width: 130,
                        item: select({options: model.statusOptions, enableFilter: false})
                    })
                ),
                formField({
                    field: 'description',
                    item: textArea()
                }),
                formField({
                    field: 'sponsor',
                    item: textInput()
                }),
                hbox(
                    formField({
                        field: 'type',
                        flex: 1,
                        item: select({options: model.typeOptions, enableFilter: false})
                    }),
                    formField({
                        field: 'objective',
                        flex: 1,
                        item: select({options: model.objectiveOptions, enableFilter: false})
                    })
                ),
                hbox(
                    formField({
                        field: 'structure',
                        flex: 1,
                        item: select({options: model.structureOptions, enableFilter: false})
                    }),

                    formField({
                        field: 'taxReporting',
                        flex: 1,
                        item: select({options: model.taxOptions, enableFilter: false})
                    })
                ),
                hbox(
                    formField({
                        field: 'capital',
                        flex: 1,
                        item: numberInput({min: 1, precision: 2, leftIcon: Icon.dollarSign()})
                    }),
                    formField({
                        field: 'inceptionDate',
                        flex: 1,
                        item: dateInput()
                    })
                ),
                hbox(
                    formField({
                        field: 'ltv',
                        flex: 1,
                        item: numberInput({
                            scaleFactor: 100,
                            leftIcon: percentageIcon()
                        })
                    }),
                    formField({
                        field: 'loanMaturityDate',
                        flex: 1,
                        item: dateInput()
                    })
                )
            )
        })
    });
});

const imagePanel = hoistCmp.factory<DealDialogModel>(({model}) => {
    return panel({
        className: 'deal-dialog__sub-panel',
        style: {height: 220},
        title: 'Image',
        compactHeader: true,
        headerItems: [
            button({
                icon: Icon.cloudUpload(),
                tooltip: 'Upload Image',
                minimal: true,
                onClick: () => model.pickImage()
            }),
            input({
                type: 'file',
                ref: model.uploadRef,
                style: {display: 'none'},
                onChange: e => model.uploadImage(e.target.files[0])
            })
        ],
        item: model.formModel.values.imageId ? img({className: 'deal-dialog__image', src: model.imageUrl}) : placeholder(Icon.camera(), 'Add Image')
    });
});

const documentsPanel = hoistCmp.factory<DealDialogModel>(() =>
    panel({
        className: 'deal-dialog__sub-panel',
        style: {height: 220},
        compactHeader: true,
        title: 'Documents',
        item: grid()
    })
);

const bbar = hoistCmp.factory<DealDialogModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Cancel',
            icon: Icon.cross(),
            onClick: () => model.close()
        }),
        button({
            text: 'Save',
            icon: Icon.check(),
            intent: 'success',
            outlined: true,
            disabled: !model.formModel.isValid,
            onClick: () => model.save()
        })
    )
);
